<!--
* @description  参数1
* @fileName  Summary
* @author userName
* @date 2024-01-29 11:59:42
!-->
<template>
  <div id="Summary" class="Summary">
    <div class="list-item">
      <div class="title">货物信息</div>
      <div class="lable-item">
        <div class="lable">材积信息</div>
        <span class="content">{{ data.quantity }},{{ data.weight }}KG</span>
      </div>
      <div class="lable-item">
        <div class="lable">总重量</div>
        <span class="content">{{ data.weight }} KG</span>
      </div>
      <div class="lable-item">
        <div class="lable">总体积</div>
        <span class="content">{{ data.volumeCbm }} CBM</span>
      </div>
      <div class="lable-item">
        <div class="lable">计费重</div>
        <span class="content">{{ data.weight }} {{ 'KG' }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">商品名称</div>
        <span class="content">{{ data.commoditiesName }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">货值</div>
        <span class="content">CNY{{ data.goodsValue }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">货好时间</div>
        <span v-show="!isEditTime" style="color:#7da7ce;" class="content" @click="eidtTime">{{ data.planDeliveryTime
        }}</span>
        <el-date-picker
          v-show="isEditTime"
          v-model="goodsReadyTime"
          type="date"
          placeholder=""
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          style="width: 70%;"
          @change="saveTime"
          @blur="eidtTimeCancel"
        />
        <span v-if="isEditTime" class="content-cancel" @click="eidtTimeCancel">cancel</span>
      </div>
    </div>
    <div class="list-item">
      <div class="title">路线</div>
      <div class="lable-item">
        <div class="lable">路线</div>
        <span class="content">{{ getAddress() }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">运输方式</div>
        <span class="content">空运</span>
      </div>
      <div class="lable-item">
        <div class="lable">服务类型</div>
        <span class="content">{{ getType() }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">时效</div>
        <span class="content">{{ data.validTerm }} days</span>
      </div>
    </div>
    <div class="list-item">
      <div class="title">下单信息</div>
      <div class="lable-item">
        <div class="lable">订单号</div>
        <span class="content">{{ data.orderNo }}
        </span>
      </div>
      <div class="lable-item">
        <div class="lable">价格有效期</div>
        <span class="content">{{ data.priceEndTime }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">下单时间</div>
        <span class="content">{{ data.creatorTimeStr }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">下单人</div>
        <span class="content">{{ data.customerName }}</span>
      </div>
    </div>
    <div class="list-item">
      <div class="title">服务信息</div>
      <slot v-if="data.isrInsurance">
        <div class="title">保险</div>
        <div class="lable-item">
          <div class="lable">申报价值</div>
          <span class="content">USD{{ data.goodsValue }}</span>
        </div>
        <div class="lable-item">
          <div class="lable">保险公司</div>
          <span class="content">{{ data.insuranceCompany }}</span>
        </div>
      </slot>

      <div class="title">目的地报关</div>
      <div class="lable-item">
        <div class="lable">商品数量</div>
        <span class="content">{{ data.commoditiesCount }}</span>
      </div>
      <div class="lable-item">
        <div v-if="data.bondType == 1" class="lable" style=" width: 200px; ">单次有效bond</div>
        <div v-if="data.bondType == 2" class="lable" style=" width: 200px; ">按年购买bond</div>
      </div>
      <div v-if="data.startLiftgateAmount > 0" class="title"> 需要起运地升降机</div>
      <div v-if="data.destLiftgateAmount > 0" class="title"> 需要目的地升降机</div>
    </div>
  </div>
</template>

<script>
import {
  UpdateGoodsReadyTime,
  GetAirOrderDetail
} from '@/api/order.js'
export default {
  name: 'Summary',
  components: {
    // 组件的引用
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      data: {},
      isEditTime: false,
      goodsReadyTime: undefined
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    // 方法
    eidtTime() {
      this.isEditTime = true
    },
    eidtTimeCancel() {
      this.isEditTime = false
    },
    saveTime(val) {
      if (val == '' || val == null) {
        return
      }
      UpdateGoodsReadyTime({
        orderNo: this.data.orderNo,
        goodsReadyTime: val
      }).then(res => {
        if (res.code === 200) {
          this.isEditTime = false
          this.initOrder(this.data.orderNo)
        }
      })
    },
    init(data) {
      this.data = data
      this.goodsReadyTime = new Date(this.data.planDeliveryTime)
    },
    initOrder(orderNo) {
      GetAirOrderDetail(orderNo).then(res => {
        if (res.code === 200) {
          this.data = res.data
        }
      })
    },
    getType() {
      switch (this.data.orderServiceType) {
        case 1:
          return '门到门'
        case 2:
          return '门到机场'
        case 3:
          return '机场到机场'
        case 4:
          return '机场到门'
      }
    },
    getAddress() {
      switch (this.data.orderServiceType) {
        case 1:
          return `${this.data.startCityNameEn},${this.data.startCountryNameEn}-->${this.data.destCityNameEn},${this.data.destCountryNameEn}`
        case 2:
          return `${this.data.startCityNameEn},${this.data.startCountryNameEn}-->${this.data.destinationCode}`
        case 3:
          return `${this.data.departureCode}-->${this.data.destinationCode}`
        case 4:
          return `${this.data.departureCode}-->${this.data.destCityNameEn},${this.data.destCountryNameEn}`
      }
    }
  }
}
</script>
<style scoped lang='scss'>
.Summary {
  display: flex;
  flex-wrap: wrap;
  width: auto;
  padding: 0 8px;

  .list-item {
    width: 524px;
    height: 256px;
    background: rgba(0, 0, 0, 0.02);
    border-radius: 8px;
    padding: 8px 16px;
    margin: 12px 12px;
    text-align: left;

    .title {
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #333333;
      height: 32px;
      line-height: 32px;
    }

    .lable-item {
      display: flex;
      height: 32px;
      align-items: center;

      .lable {
        font-size: 13px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #666666;
        width: 132px;
      }

      .content {
        font-size: 13px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #333333;
      }

      .content-cancel {
        color: #E95506;
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }
}
</style>
